import BreadCrumb from "Common/BreadCrumb";
import { useEffect, useState } from "react";
import { Container, Button, Card, Table, Modal } from "react-bootstrap";
import { settingServices } from "Utils/setting/services";
import snackbarUtil from "Utils/snackBarUtil";

const BetProcessList = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [agent, setAgentData] = useState<any[]>([]);
  const [betList, setBetList] = useState<any[]>([]);

  const getShowAgent = async (user_id: string) => {
    try {
      const payload = {
        user_id: user_id,
      };
      const { response } = await settingServices.getShowAgent(payload);
      setAgentData(response?.data?.agents);
    } catch (error) {
      console.log(error);
    }
  };
  const getBetProcessList = async () => {
    try {
      const { response } = await settingServices.getBetProcessList();
      setBetList(response?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getUserBetProces = async () => {
    try {
      const { response } = await settingServices.getUserBetProces();
      if (response) {
        if (response?.status) {
          snackbarUtil.success(response?.msg);
          getBetProcessList();
        } else {
          snackbarUtil.error(response?.msg);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBetProcessList();
  }, []);

  const handlePOpen = (user: any) => {
    setSelectedUser(user);
    setShowModal(true);
    getShowAgent(user?._id);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <div className="position-relative mb-2 d-flex justify-content-between align-items-center">
          <BreadCrumb
            title="Bet Process User List"
            pageTitle="Dashboard"
            back
          />
          <Button
            variant="info"
            className="btn-sm me-1"
            onClick={() => getUserBetProces()}
          >
            Clear All Bet List
          </Button>
        </div>

        <Card>
          <Card.Body>
            <div className="table-resposive">
              <Table>
                <thead className="table-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Status Update</th>
                  </tr>
                </thead>
                <tbody>
                  {betList?.length !== 0 ? (
                    betList?.map((items: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{items?.user_name}</td>

                          <td>
                            <Button
                              variant="info"
                              className="btn-sm me-1"
                              onClick={() => handlePOpen(items)}
                            >
                              P
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </Container>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Parent List of {selectedUser?.user_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <table className="table">
              <tbody>
                {agent?.map((item: any) => {
                  return (
                    <tr>
                      <td>{`${item?.name} (${item?.user_name})`}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BetProcessList;
